import cookies from 'js-cookie';
import api from '../../marketing/api';
import { select } from '../../shared/utils/dom';
import { delimiters } from '../../shared/constants';

const unAuthChatBotCookieName = 'UnAuthChatConnection';
const authChatBotCookieName = 'AuthChatConnection';
const el = select('[data-vue-app="authenticated-web-chat"]');
if (el) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el,
    delimiters,
    data: {
      pageFriendlyname: '',
    },
    mounted() {
      if (this.$el.dataset.sourceName) {
        this.pageFriendlyname = this.$el.dataset.sourceName;
      }
      const baseDomain = location.hostname.split(".").slice(-2).join(".");
      if (cookies.get(unAuthChatBotCookieName, { domain: baseDomain }) && cookies.get(unAuthChatBotCookieName, { domain: baseDomain }) === 'true') {
        window.isConnect().then((isConnected) => {
          if (isConnected) {
            window.endConversation();
          }
        });
        cookies.remove(unAuthChatBotCookieName, { domain: baseDomain });
      }
      if (cookies.get(authChatBotCookieName, { domain: baseDomain }) && cookies.get(authChatBotCookieName, { domain: baseDomain }) === 'true') {
        window.isConnect().then((isConnected) => {
          if (isConnected) {
            window.chatBotOpenClose(true);
            const activityData = {
              sourceurl: window.location.href,
              friendlyName: this.pageFriendlyname,
            }
            window.updateActivityData(activityData);
          }
        });
      }
    },
    methods: {
      openChat() {
        const baseDomain = location.hostname.split(".").slice(-2).join(".");
        if (!(cookies.get(authChatBotCookieName, { domain: baseDomain }) && cookies.get(authChatBotCookieName, { domain: baseDomain }) === 'true')) {
          this.invokeCustomerDetailsAndSendtoChatBot();
        } else {
          window.isConnect().then((isConnected) => {
            if (!isConnected) {
              this.invokeCustomerDetailsAndSendtoChatBot();
            }
          });
        }
      },
      invokeCustomerDetailsAndSendtoChatBot() {
        api.get('/webchatinformation', {}, false)
          .then(response => {
            if (response && typeof (response.data) === 'object') {
              const activityData = {
                serviceaccountnumber: response.data.serviceAccountNumber ? response.data.serviceAccountNumber : '',
                firstname: response.data.firstName,
                lastname: response.data.lastName,
                osType: undefined,
                browser: undefined,
                browserVersion: undefined,
                sourceurl: window.location.href,
                division: response.data.division ? response.data.division : response.data.ldcOfDomain,
                vlgSession: response.data.vlgSession,
                isAuthenticated: true,
                xsrfToken: cookies.get("vlgXsrf"),
                ldcOfDomain: response.data.ldcOfDomain,
                multipleAccounts: response.data.multipleAccounts ? response.data.multipleAccounts : '',
                premiseId: response.data.premiseId ? response.data.premiseId : '',
                friendlyName: this.pageFriendlyname,
              }
              const baseDomain = location.hostname.split(".").slice(-2).join(".");
              cookies.set(authChatBotCookieName, true, { domain: baseDomain });
              window.updateActivityData(activityData);
            } else {
              console.log("Could not map chat bot information");
            }
          })
          .catch(() => {
            console.log("Could not fetch chat bot information");
          });
      },
    },
  });
}
const unauthel = select('[data-vue-app="unauthenticated-web-chat"]');
if (unauthel) {
  const app = new Vue({ // eslint-disable-line no-unused-vars
    el: unauthel,
    delimiters,
    data: {
      pageFriendlyname: '',
    },
    mounted() {
      if (this.$el.dataset.sourceName) {
        this.pageFriendlyname = this.$el.dataset.sourceName;
      }
      const baseDomain = location.hostname.split(".").slice(-2).join(".");
      if (cookies.get(authChatBotCookieName, { domain: baseDomain }) && cookies.get(authChatBotCookieName, { domain: baseDomain }) === 'true') {
        window.isConnect().then((isConnected) => {
          if (isConnected) {
            window.endConversation();
          }
        });
        cookies.remove(authChatBotCookieName, { domain: baseDomain });
      }
      if (cookies.get(unAuthChatBotCookieName, { domain: baseDomain }) && cookies.get(unAuthChatBotCookieName, { domain: baseDomain }) === 'true') {
        window.isConnect().then((isConnected) => {
          if (isConnected) {
            window.chatBotOpenClose(true);
            const activityData = {
              sourceurl: window.location.href,
              friendlyName: this.pageFriendlyname,
            }
            window.updateActivityData(activityData);
          }
        });
      }
    },
    methods: {
      openChat() {
        const baseDomain = location.hostname.split(".").slice(-2).join(".");
        if (!(cookies.get(unAuthChatBotCookieName, { domain: baseDomain }) && cookies.get(unAuthChatBotCookieName, { domain: baseDomain }) === 'true')) {
          this.sendUnAuthDetailsToChatBot();
        } else {
          window.isConnect().then((isConnected) => {
            if (!isConnected) {
              this.sendUnAuthDetailsToChatBot();
            }
          });
        }
      },
      sendUnAuthDetailsToChatBot() {
        const baseDomain = location.hostname.split(".").slice(-2).join(".");
        const activityData = {
          serviceaccountnumber: '',
          firstname: '',
          lastname: '',
          osType: undefined,
          browser: undefined,
          browserVersion: undefined,
          sourceurl: window.location.href,
          division: window.ldcCode,
          vlgSession: '',
          isAuthenticated: false,
          xsrfToken: '',
          ldcOfDomain: window.ldcCode,
          multipleAccounts: '',
          premiseId: '',
          friendlyName: this.pageFriendlyname,
        }
        cookies.set(unAuthChatBotCookieName, true, { domain: baseDomain });
        window.updateActivityData(activityData);
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/web-chat.js